import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataStorageService } from '../data-storage.service';
import { FormArray } from '@angular/forms';
import { VehicleForm } from '../vehicle-form/vehicle-form.component';
import { VEHICLE_TAB_NAME } from '../../utils/constants';
import { UserData } from '../../utils/types';
import { markFormAsTouched, getSegmentPage } from 'src/utils/operations';
import { isScreenSmall } from 'src/utils/screen';
import { SegmentService } from '../segment.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { phoneMask } from '../../utils/masks';
import { WebServicesService } from '../web-services.service';

@Component({
  selector: 'app-vehicle-config',
  templateUrl: './vehicle-config.component.html',
  styleUrls: ['./vehicle-config.component.scss'],
})
export class VehicleConfigComponent implements OnInit {
  name: string;
  form = new FormArray([
    new VehicleForm(),
  ]);

  userForm = new FormGroup({
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\(\d{3}\) \d{3}-\d{4}$/),
    ]),
    serviceOptIn: new FormControl(false),
  });

  phoneMask = phoneMask;

  get currentItem() {
    return Number(this.activatedRoute.snapshot.queryParamMap.get('currentItem')) || 0;
  }

  set currentItem(currentItem) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { currentItem },
      replaceUrl: true,
    });
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private storage: DataStorageService,
    private segment: SegmentService,
    private webServices: WebServicesService,
  ) {}

  ngOnInit() {
    const data = this.storage.getData();
    if (data) {
      this.setComponentData(data);
    }
  }

  setComponentData({ first_name = '', phone = '', serviceOptIn = false, vehicles = [] }: UserData) {
    this.name = first_name;
    // this.userForm.setValue({phone})
    // this.userForm.setValue({serviceOptIn})
    vehicles.forEach((vehicle, i) => {
      const vehicleForm = new VehicleForm();
      vehicleForm.patchValue(vehicle);
      this.form.setControl(i, vehicleForm);
    });

    if (this.activatedRoute.snapshot.queryParamMap.get('new')) {
      this.addVehicle();
    } else if (this.currentItem >= this.form.length) {
      this.currentItem = this.form.length - 1;
    }
  }

  getTabs() {
    let tabName = VEHICLE_TAB_NAME;
    if (isScreenSmall()) {
      tabName = tabName.slice(0, 1);
    }
    return this.form.controls.map(
      (_, i) => tabName + (i + 1),
    );
  }

  onTabChange(index: number) {
    this.currentItem = index;
  }

  addVehicle() {
    this.form.push(new VehicleForm());
    this.currentItem = this.form.length - 1;
    this.trackVehicles();
  }

  deleteVehicle() {
    this.form.removeAt(this.currentItem);
    if (this.currentItem === this.form.length) {
      this.currentItem--;
    }
  }

  onNextClick() {
    if (this.form.invalid) {
      markFormAsTouched(this.form);
      this.currentItem = this.form.controls.findIndex(
        control => control.invalid,
      );

      return;
    }

    if (this.userForm.invalid) {
      markFormAsTouched(this.userForm);
      this.currentItem = this.form.length - 1;
      
      return;
    }

    const vehicles = this.form.getRawValue();
    this.storage.patchData({
      vehicles: vehicles.map(vehicle => ({
        ...vehicle,
        coverage: 'basic',
      })),
      phone: this.userForm.get("phone").value,
      serviceOptIn: this.userForm.get("serviceOptIn").value
    });
    this.trackVehicles();
    this.router.navigate(['driver'], { queryParamsHandling: "preserve" });
    if(this.storage.getData().phone) {
      this.webServices.catchApplicants(this.storage.getData()).subscribe(() => {});
    }
  }

  onBackClick() {
    if(this.form.length > 1){
      this.deleteVehicle()
    } else {
      this.router.navigate([".."], { queryParamsHandling: "preserve" } );
    }
  }

  trackVehicles() {
    this.segment.track(`${getSegmentPage()} VehicleSelected`, {
      vehicles: this.form.getRawValue(),
    });
  }
}
